var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "section-body" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.query,
                expression: "query"
              }
            ],
            attrs: { disabled: _vm.selected, id: "search", type: "text" },
            domProps: { value: _vm.query },
            on: {
              keyup: function($event) {
                return _vm.search(_vm.query)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.query = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "search" } }, [_vm._v("cliente")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selected,
                expression: "selected"
              }
            ],
            staticClass: "clear",
            on: {
              click: function($event) {
                return _vm.clearSelected()
              }
            }
          },
          [_vm._v("x")]
        )
      ]),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.clients, function(client, index) {
          return _c(
            "li",
            {
              key: index,
              on: {
                click: function($event) {
                  return _vm.select(client)
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    client.attributes.first_name +
                      " " +
                      client.attributes.last_name
                  ) +
                  "\n      "
              )
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _vm._v("\n    AGENDE UMA LIMPEZA\n    "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4965b76a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4965b76a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/OrdersAndSubscriptions/Client.vue
// module id = null
// module chunks = 